





























import { Component, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Enums/Data
import { AdminRoutes } from "@/data/enums/router";
import { Location } from "vue-router";

// Types
import {
  ICProdProvider,
  ICProdProviderMethods
} from "@/models/providers/contractProduct";
import { ICProdProvProviderMethods } from "@/models/providers/contractProduct";
import { IProvisionRequest } from "@/models/provisioning";

@Component
export default class CProdUnresolvedProvisionRequests extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: ICProdProviderMethods;

  @Inject({ from: "cProdProvProviderMethods" })
  public readonly $cProdProvMethods!: ICProdProvProviderMethods;

  // Variables

  public isResolving = false;

  // Methods

  public async manuallyResolveAllRequests() {
    if (!this.canManuallyResolveRequest || this.isResolving) return;
    try {
      this.isResolving = true;
      await Promise.all(
        this.$_.map(this.requests, request => {
          return this.$cProdProvMethods.manuallyResolveRequest(request.id);
        })
      );
      await this.$cProdMethods.reloadData();
      this.$bus.$emit("refreshRequestTable");
      this.$store.dispatch("toast/show", {
        message: this.$t("_.all_requests_resolved")
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isResolving = false;
    }
  }

  // Computed

  public get requests(): IProvisionRequest[] {
    return (
      this.$cProdData().contractProduct?.unresolved_provision_requests || []
    );
  }

  public get canManuallyResolveRequest() {
    return this.$userCan("update_provision_request");
  }

  public get cProdProvisioningRoute(): Location {
    return {
      name: AdminRoutes.CONTRACT_PRODUCT_PROVISIONING,
      params: {
        clientId: this.$cProdData().contract.client_id,
        contractId: this.$cProdData().contract.id,
        productId: this.$cProdData().contractProduct.id
      }
    };
  }
}
